<template>
<div class="slide">

        <go-back />

    <div class="slide-container">

        <div class="question bigger">
            Is {{ personTwo.name }} <span>still working</span> or <span>retired</span>?
        </div>

        <div class="answer answer-col">
            <span class="alternative" @click="setPersonTwoIsWorking(true)">Working</span>
            <span class="alternative" @click="setPersonTwoIsWorking(false)">Retired</span>
        </div>

    </div>

</div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import GoBack from "./GoBack";
    export default {
        name: 'PersonTwoWorkingRetired',
        components: {
            GoBack
        },
        methods: {
            setPersonTwoIsWorking(isWorking) {
                this.$store.commit('individuals/setPersonTwoIsWorking', isWorking);

                if (!this.personOneIsWorking && !this.personTwoIsWorking) {
                    this.$router.push({ name: 'IndividualAge' });
                } else {
                    this.$router.push({ name: 'ExpectRetirement' });
                }
            },
        },
        computed: {
            ...mapGetters('individuals', [
                'personTwo',
                'personOneIsWorking',
                'personTwoIsWorking',
            ]),
        }
    }
</script>
